import {Inject, Injectable} from '@angular/core';
import {Person} from '../_models/person';
import {BaseService} from './base-service';
import {Tab} from '../_models/tab';
import {Order} from '../_models/order';
import {EditPersonModalComponent} from '../_components/edit-person-modal/edit-person-modal.component';
import {HttpClient} from '@angular/common/http';
import {LibConfig, LibConfigService} from '../lib.config';
import {ModalController} from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class PersonService extends BaseService<Person> {
    destination = 'persons';
    active = false;

    constructor(
        public http: HttpClient,
        @Inject(LibConfigService) public config: LibConfig,
        private modalController: ModalController
    ) {
        super(http, config);
    }

    requirePersonInformation(tab: Tab, order: Order): {
        requireFirstName: boolean,
        requireLastName: boolean,
        requireMobile: boolean,
        requireEmail: boolean,
        person: Person,
        valid: boolean,
        nameOnly: boolean,
        title: string
    } {
        const response = {
            requireFirstName: false,
            requireLastName: false,
            requireMobile: false,
            requireEmail: false,
            person: null,
            valid: true,
            nameOnly: false,
            title: 'Contact Information'
        };

        const person = !!tab && !!tab.person ? tab.person : new Person();

        if (!!tab
            && (!!tab.deposits || !!tab.invoiceToken)
            && (!tab.person
                || !tab.person.email
                || !tab.person.mobile
                || !tab.person.name
                || tab.person.name === 'Invoice Customer')
        ) {
            response.requireEmail = true;
            response.requireMobile = true;
            response.requireFirstName = true;
            response.requireLastName = true;
        } else if (!!tab && !!order) {
            response.requireFirstName = order.items.some(i => !!i.menuItem
                && !i.menuItem.requirePersonPerItem
                && i.menuItem.requireFirstName);

            response.requireLastName = order.items.some(i => !!i.menuItem
                && !i.menuItem.requirePersonPerItem
                && i.menuItem.requireLastName);

            response.requireMobile = order.items.some(i => !!i.menuItem
                && !i.menuItem.requirePersonPerItem
                && i.menuItem.requireMobile);

            response.requireEmail = order.items.some(i => !!i.menuItem
                && !i.menuItem.requirePersonPerItem
                && i.menuItem.requireEmail);

        }

        response.valid = (!response.requireFirstName || (!!person.firstName && person.name !== 'Invoice Customer' && person.name !== 'Single Pay'))
            && (!response.requireLastName || !!person.lastName && person.name !== 'Invoice Customer' && person.name !== 'Single Pay')
            && (!response.requireMobile || !!person.mobile)
            && (!response.requireEmail || !!person.email);

        response.person = person as Person;

        return response;
    }

    async editPersonInformation(validationRequirement: {
        requireFirstName: boolean,
        requireLastName: boolean,
        requireMobile: boolean,
        requireEmail: boolean,
        person: Person,
        valid: boolean,
        nameOnly: boolean,
        title: string
    }): Promise<Person> {
        if (!this.active) {
            this.active = true;
            const modal = await this.modalController.create({
                component: EditPersonModalComponent,
                componentProps: {
                    person: validationRequirement.person,
                    skipSave: true,
                    requireFirstName: validationRequirement.requireFirstName,
                    requireLastName: validationRequirement.requireLastName,
                    requireMobile: validationRequirement.requireMobile,
                    requireEmail: validationRequirement.requireEmail,
                    nameOnly: validationRequirement.nameOnly,
                    title: validationRequirement.title
                }
            });

            await modal.present();

            return await modal.onDidDismiss().then(async (dataReturned) => {
                this.active = false;
                if (dataReturned !== null && dataReturned.data != null) {
                    return Promise.resolve(dataReturned.data as Person);
                } else {
                    return Promise.resolve(null);
                }
            });
        }
    }
}
